import { render, staticRenderFns } from "./teamPagePar.vue?vue&type=template&id=3d75359a&scoped=true&"
import script from "./teamPagePar.vue?vue&type=script&lang=js&"
export * from "./teamPagePar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d75359a",
  null
  
)

export default component.exports